<template>
<header class="new-header" id="new-header">
    <div class="new-inrContent wh-100 flex-b--c">
        <div class="header-left flex-s--c">
            <figure class="logo-wrap" style="margin-top:5px;">
                <img src="@/assets/new_images/g-logo.png" alt="고시락 로고" class="logo">
                <span class="text-indent">고시락</span>
            </figure>
            <span class="download-btn">
                <a :href="kosirockPromotion.link" target="_blank">
                    {{kosirockPromotion.title}}
                </a>
            </span>
        </div>
        <div class="header-right">
            <ul class="gnb-wrap d-inlineflex">
                <li class="gnb-list" v-for="(item, idx) in menuList" :key="idx">
                    <a @click="menuAction(item)">
                        {{item.title}}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</header>
</template>

<script>
export default {
    data() {
        return {
            kosirockPromotion: {
                title: "고시락 홍보 방법",
                link: "/kosirock_information_220311.pdf"
            },

            menuList: [{
                title: "지도로 찾기",
                link: "/search?latitude=37.5546788388674&longitude=126.970606917394",
                blank: false
            }, {
                title: "관심 목록",
                link: "/interest",
                blank: false
            }, {
                title: "고시원 올리기",
                // link: "http://ad.kosirock.com/#/register",
                link: "/register",
                blank: true
            }, {
                title: "고시원 창업",
                link: "https://franchise.huesik.co.kr/",
                blank: true
            }]
        }
    },
    methods: {
        menuAction(item) {
            if (item.blank) {
                window.open(item.link);
            } else {
                this.$router.push(item.link);
            }
        }
    }
}
</script>
